




































import { Vue, Component, Prop } from 'vue-property-decorator'
import PromptModel from '@/models/investigation/promptModel'
import { getModule } from 'vuex-module-decorators'
import ExtensionModule from '@/store/extensionModule'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import RootCauseModel from '../models/investigation/rootCauseModel'

const extensionModule = getModule(ExtensionModule)

@Component
export default class ActionPrompt extends Vue {
  @Prop(String) readonly id!: string

  private prompt: PromptModel = new PromptModel()

  private loading: boolean = false

  private rootCauses: RootCauseModel[] = []

  private headers: any[] = [{ text: 'Root Cause', value: 'codeRootCause' }]

  private categories: Array<string> = ['ESP', 'HB', 'ORG']

  async created(): Promise<void> {
    await this.getPrompt()
    await this.getRootCauses()
  }

  private async getPrompt(): Promise<void> {
    this.prompt = await ApiService.get<PromptModel>(
      UrlType.ExtensionPrompt,
      this.id
    )
  }

  private async getRootCauses(): Promise<void> {
    this.rootCauses = await ApiService.getAll(UrlType.RootCauseBase)
  }

  private async savePrompt(): Promise<void> {
    this.prompt = await ApiService.put<PromptModel>(
      UrlType.ExtensionPrompt,
      this.id,
      this.prompt
    )
  }
}
